import { forwardRef, useContext, useState } from "react";
import { AppBar, Box, Dialog, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { Office365GroupContext } from "../../context/Office365GroupContext";
import { Office365GroupDetailPanel } from "./Office365GroupDetailPanel";
import { ModuleContext } from "../../context/ModuleContext";
import { ModuleContainer } from "../ModuleContainer";
import { Office365CreateGroupTable } from "./Office365CreateGroupTable";
import { Office365GroupOptionsMenu } from "./Office365GroupOptionsMenu";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const Office365GroupsContainer = () => {
    const { groupModule, setGroupModule } = useContext(Office365GroupContext);

    const [module, setModule] = useState({
        isVisible: false,
        element: null,
        validated: false,
        validationError: null,
        userId: null,
        isLog: false,
    });

    const handleClose = () => {
        setGroupModule((prev) => ({ ...prev, isOpen: false }));
    };

    return (
        <Dialog fullScreen open={groupModule.isOpen} TransitionComponent={Transition}>
            <ModuleContext.Provider value={{ module, setModule }}>
                <ModuleContainer />

                <AppBar sx={{ position: "relative", backgroundColor: "#A60F2D", color: "white" }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {groupModule.mode === "read" ? groupModule.displayName : "Create Office 365 Group"}
                        </Typography>
                    </Toolbar>
                </AppBar>

                {groupModule.mode === "create" && (
                    <Box sx={{ width: "100%", p: 3, flex: 1, minHeight: 0, overflowY: "auto" }}>
                        <Office365CreateGroupTable />
                    </Box>
                )}

                {groupModule.mode === "read" && (
                    <Box sx={{ display: "flex", flexDirection: "row", p: 2, gap: 3, alignItems: "flex-start", flex: 1, minHeight: 0, overflowY: "auto" }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Office365GroupDetailPanel />
                        </Box>
                        {groupModule.data !== null && (
                            <Box sx={{ flexShrink: 0 }}>
                                <Office365GroupOptionsMenu />
                            </Box>
                        )}
                    </Box>
                )}
            </ModuleContext.Provider>
        </Dialog>
    );
};